export default __webpack_public_path__ + "static/media/abt_desktop.475c2628.jpg";